import React from 'react'
import Sidebar from '../components/Sidebar'
import Chatlist from '../components/Chatlist'
import Input from '../components/Input'
import Search from '../components/Search'
import Message from '../components/Message'

import '../App.css'
const Chatpage = () => {
  return (
    <div className='chat-home '>
        <div className="contain">
            <Sidebar />
            <Message />
        </div>
    </div>
  )
}

export default Chatpage